import { CommonModule } from '@angular/common';
import { Component, input, InputSignal, OnInit } from '@angular/core';
import { ActivityPanelModes } from '../../../constants.new';
import { ActivityService } from '../activity.service';

@Component({
    selector: 'activity-summary-table',
    templateUrl: 'activitySummaryTable.component.html',
    imports: [CommonModule],
})
export class ActivitySummaryTableComponent implements OnInit {
    constructor(private readonly _activityService: ActivityService) {}

    annualData: InputSignal<any[]> = input();
    propCharacteristics: InputSignal<any> = input();
    selectedYear: InputSignal<number> = input();

    ActivityPanelModes = ActivityPanelModes;
    appealStatus: string = '';
    acres: any;
    impsSqFt: any;
    units: any;
    currentYear: any;
    fmvProjected: boolean = false;
    recentSavings: any[] = [];
    totalTaxes: number = 0;
    taxProjected: boolean = false;

    async ngOnInit() {
        try {
            this.appealStatus = '';
            this.getPropertyCharacteristics();

            this.currentYear = this.annualData().find((x) => x.year === this.selectedYear());

            this.currentYear.totalFMV = Math.round(this.currentYear.totalFMV);

            this.fmvProjected = this.currentYear.fmvByPropertyType.some((x) => x.isProjected);

            this.recentSavings = this.annualData().filter((x) => x.taxSavings?.savings > 0);

            this.totalTaxes = this.currentYear.collectorTaxes.reduce((sum, n) => {
                return new Decimal(sum).plus(n.tax).toNumber();
            }, 0);
            this.taxProjected = this.currentYear.collectorTaxes.some((x) => x.isProjected);

            this.getAppealsStatusLabel(this.currentYear.taxSavings.status);
        } catch (ex) {
            console.log(`ERROR: ${ex}`);
        }
    }

    getAppealsStatusLabel(status): void {
        switch (status) {
            case 'No Appeal':
                this.appealStatus = 'No';
                break;
            case 'N/A':
                this.appealStatus = 'N/A';
                break;
            default:
                this.appealStatus = status;
        }
    }

    getPropertyCharacteristics(): void {
        this.acres = this.propCharacteristics().find((x) => x.label === 'Land Acreage');
        this.impsSqFt = this.propCharacteristics().find((x) => x.label === 'Imps. SqFt');
        this.units = this.propCharacteristics().find((x) => x.label === 'Units');
    }

    updateChartType(chartType: ActivityPanelModes) {
        this._activityService.chartTypeChanged(chartType);
    }
}
